var map = {
	"./Abstract-Anomaly.jpg": 453,
	"./Chamille.jpg": 9950,
	"./Cicada.jpg": 9006,
	"./City-on-clouds.jpg": 3559,
	"./Dreamworld.jpg": 1440,
	"./Flamity.jpg": 5207,
	"./FullGlass.jpg": 1458,
	"./Glow.jpg": 5744,
	"./Grace.jpg": 5471,
	"./Greenhouse.jpg": 6884,
	"./Growth.jpg": 5358,
	"./Hope.jpg": 685,
	"./Master-copy-of-Louisa-Matthiasdottirs-work.jpg": 5530,
	"./MushTown.jpg": 1228,
	"./Octo.png": 7562,
	"./Podilia.jpg": 2779,
	"./Portrait-of-Roksolana.jpg": 3761,
	"./Saturn.jpg": 4006,
	"./Snaility.jpg": 3822,
	"./Sun-Earth.jpg": 3962,
	"./Tail.jpg": 9449,
	"./Travel.jpg": 9731,
	"./Tree1.jpg": 3010,
	"./TurtleVille.jpg": 6109,
	"./Up.jpg": 8292,
	"./WorldsEnergy.jpg": 5484,
	"./chicken.jpg": 3606,
	"./colibri.jpg": 7127,
	"./dou-color-Abstract.jpg": 9194,
	"./heart.jpg": 7387,
	"./kharkiv.jpg": 1325,
	"./kingsfisher.jpg": 3040,
	"./kurka.jpg": 3477,
	"./macaw.jpg": 9306,
	"./pattern.jpg": 9777,
	"./peacock.jpg": 137,
	"./rooster.jpg": 7999,
	"./rooster1.jpg": 6978,
	"./rushnyk.jpg": 1987,
	"./snowy_egret.jpg": 9949,
	"./stork.jpg": 3566,
	"./tucan.jpg": 9998,
	"./vyshyvka.jpg": 9976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7143;